import React from 'react';
import CheckIcon from '@material-ui/icons/Check';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import Tooltip from 'components/Tooltip';
import JuvenileIndicator from 'global-components/JuvenileIndicator';
import { CodeTagTypeIconRender, IsJuvenile, genColHeaderName } from 'utils/functions';
import { displayDateTime } from 'reducers/TimeReducer';
import { fullNameColumnWithIcon } from 'features/shared/utility/UrgentMessageHelper';
import ColumnFinder from 'components/RMSXGrid/ColumnFinder';

const bool = (params) => (params.value ? <CheckIcon /> : <span></span>);

const renderJuvenile = (params) => {
  const { row } = params;
  return (
    <JuvenileIndicator
      IsJuvenile={IsJuvenile('person', {
        dob: row.BirthDate,
        age: row.Age,
      })}
      text="JUV"
      customStyle={{ width: '40px', height: '30px', marginRight: '15px' }}
    />
  );
};

const iconRender = (params) => {
  if (!params.row.Tags) return;
  const json_data = JSON.parse(params.row.Tags);

  return (
    <span>
      {json_data.map((item, idx) => {
        const icon = item.c[0].Icon;
        const tagData = {
          created: item.Created,
          createdBy: item.CreatedBy,
          updated: item.Updated,
          updatedBy: item.UpdatedBy,
          type: item.Type,
          typeDescription: item.c[0].TypeDescription,
          description: item.Value,
        };
        const TagIcon = CodeTagTypeIconRender(icon, 'small', '20px', tagData);
        return <span key={idx}>{TagIcon}</span>;
      })}
    </span>
  );
};

export const PERSON_SEARCH_COLUMNS = [
  {
    field: 'IsUser',
    headerName: ' ',
    width: 50,
    renderCell: (params) => {
      if (params.value) {
        return (
          <Tooltip title={'Existing user'}>
            <span style={{ display: 'inline-flex' }}>
              <HowToRegIcon />
            </span>
          </Tooltip>
        );
      }
      return <></>;
    },
  },
  'PersonID',
  { field: 'Tags', headerName: 'Tag', width: 200, hide: false, renderCell: iconRender },
  {
    field: 'Juvenile',
    headerName: 'Juvenile',
    width: 150,
    hide: false,
    renderCell: renderJuvenile,
  },
  fullNameColumnWithIcon(),
  'FirstName',
  'MiddleName',
  'LastName',
  'Suffix',
  'NickName',
  'Age',
  'Sex',
  'OLN',
  'SSN',
  {
    field: 'BirthDate',
    headerName: 'DOB',
    width: 150,
  },
  { field: 'Deceased', renderCell: bool },
  { field: 'Died', width: 150 },
  { field: 'ActiveWarrant', renderCell: bool },
  { field: 'Incarcerated', renderCell: bool },
  { field: 'Officer', renderCell: bool },
  { field: 'PublicOfficial', renderCell: bool },
  { field: 'ProtectiveOrder', renderCell: bool },
  { field: 'SexOffender', renderCell: bool },
  { field: 'Military', renderCell: bool },
  { field: 'ConcealedWeaponPermit', headerName: 'Concealed Weapon', renderCell: bool },
  { field: 'SeniorCitizen', renderCell: bool },
  { field: 'Dangerous', renderCell: bool },
  { field: 'Gang', renderCell: bool },
  'Ethnicity',
  'EyeColor',
  'HairColor',
  'Race',
  'Height',
  'Weight',
  {
    field: 'Created',
    headerName: 'Created',
    width: 200,
    valueFormatter: (params) => displayDateTime(params.value),
  },
  {
    field: 'CreatedBy',
    headerName: 'CreatedBy',
    width: 150,
  },
  {
    field: 'Updated',
    headerName: 'Updated',
    width: 200,
    valueFormatter: (params) => displayDateTime(params.value),
  },
  {
    field: 'UpdatedBy',
    headerName: 'UpdatedBy',
    width: 150,
  },
];

const deletedColumns = ['IsDeleted', 'Deleted', 'DeletedBy', 'DeletedIP'];
export const PERSON_SEARCH_COLUMNS_WITH_DELETED = [...PERSON_SEARCH_COLUMNS, ...deletedColumns];

export const getPersonMergeColumns = (canViewDeleted) => {
  const columns = canViewDeleted ? PERSON_SEARCH_COLUMNS_WITH_DELETED : PERSON_SEARCH_COLUMNS;
  return columns.map((column) => {
    const definition =
      typeof column === 'string'
        ? ColumnFinder.find((item) => item.field === column) || { field: column }
        : column;
    return {
      ...definition,
      width: definition.width || 150,
      headerName: definition.headerName || genColHeaderName(definition.field),
    };
  });
};
